


























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import InvestmentAccountTypeFeeDetails from "@/shared/components/investments/drivewealth/InvestmentAccountTypeFeeDetails.vue";
import {
DrivewealthAccountManagementType,
  DrivewealthAccountSummary,
  InvestmentManagementType
} from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    InvestmentAccountTypeFeeDetails
  }
})
export default class InvestmentAccountTypeLink extends Vue {
  drivewealthStore = useDrivewealthStore();

  formatCurrency = formatCurrency;

  @Prop()
  account: DrivewealthAccountSummary;

  @Prop()
  accountType: DrivewealthAccountManagementType;

  @Prop()
  isHsaBank: boolean;

  @Prop()
  accountTypeName: string;

  @Prop()
  accountTypeDescription: string;

  @Prop()
  icon: string;

  get hasAccount (): boolean {
    return this.account !== undefined;
  }

  get formattedDateNow (): string {
    return moment().format("MMM DD");
  }

  get anchorClasses () {
    return {
      "d-flex": true,
      "align-items-center": true,
      "jumbotron-link-container": true,
      "disabled": this.hasAccount
    };
  }

  setAccountType () {
    if (!this.hasAccount) {
      this.$emit("selected", this.accountType);
    }
  }
}
